import { render, staticRenderFns } from "./Dropzone.vue?vue&type=template&id=78f05b22&"
import script from "./Dropzone.vue?vue&type=script&lang=js&"
export * from "./Dropzone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports